import ApplicationComponent from "legacy/ApplicationComponent"
import TermsModal from "legacy/TermsModal"
import PropTypes from "prop-types"
import React from "react"

class MarinaTermsModal extends ApplicationComponent {
  render() {
    return (
      <TermsModal
        userId={this.props.userId}
        endpoint={this.props.endpoint}
        showModal={this.props.showModal}
        marinaSide={true}
        backdrop="static"
      >
        <h2 className="mt-0 text-lg font-bold">Terms of Service Update</h2>
        <p>
          We&apos;re updating our Terms of Service in our{" "}
          <a
            href="https://ahoy.dockwa.com/about-us/saas-terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            SaaS Agreement
          </a>{" "}
          effective May 2022.
        </p>
        <p>
          This update includes new language specific to marina customers that
          purchase Dockwa hardware, like the new POS card swipers. Nothing is
          changing for software customers that do not purchase hardware.
        </p>
        <p>
          Whether or not you chose to purchase hardware, we encourage you to
          review the updated{" "}
          <a
            href="https://ahoy.dockwa.com/about-us/saas-terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            SaaS Agreement
          </a>{" "}
          in full, which will apply to you if you have an active subscription{" "}
          <span className={"font-semibold"}>AND</span> elect to purchase
          supporting hardware.
        </p>
        <p>Thank you for being a part of the Dockwa Community.</p>
      </TermsModal>
    )
  }
}

MarinaTermsModal.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  endpoint: PropTypes.string.isRequired,
  showModal: PropTypes.bool,
}

export default MarinaTermsModal
